<script lang="ts">
    import { baseURL, companyName } from "../../configs/config"
    import { langField } from "../../i18n"
    import { location } from "../../i18n"
    import { firstProductImage } from "../../utils"

    let {
        // article = false, // isArticle – bei Bedarf aktivieren
        datePublished = null,
        lastUpdated = null,
        metaDescription = "",
        pageTitle = "",
        product = null,
    }: {
        // article: boolean // isArticle – bei Bedarf aktivieren
        datePublished: Date | null
        lastUpdated: Date | null
        metaDescription: string
        pageTitle: string
        product: TProduct
    } = $props()

    function toAbsoluteUrl(url: string): string {
        if (!url) return ""
        return /^https?:\/\//i.test(url) ? url : `${baseURL}${url}`
    }

    const productOgImage = $derived(
        product ? toAbsoluteUrl(firstProductImage(product, "1080-shadow")) : `${baseURL}/api/_/assets/logo/logo.png`
    )
</script>

<svelte:head>
    <meta property="og:locale" content={"de_DE"} />
    <meta property="og:url" content={$location.url?.split("?")[0] || ""} />
    <meta property="og:type" content={product ? "og:product" : "website"} />
    <meta property="og:title" content={pageTitle} />
    <meta property="og:description" content={metaDescription} />
    {#if product}
        <meta property="og:image" content={productOgImage} />
        <meta property="og:image:alt" content={langField(product.name)} />
        <meta property="og:image:width" content="1080" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={metaDescription} />
        {#if product.images?.length}
            <meta name="twitter:image" content={productOgImage} />
            <meta name="twitter:image:alt" content={langField(product.name)} />
        {/if}
    {:else}
        <meta property="og:image" content="{baseURL}/api/_/assets/logo/logo.png" />
        <meta property="og:image:width" content="1000" />
        <meta property="og:image:height" content="523" />
        <meta property="og:image:alt" content="{companyName} Logo" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content="{baseURL}/api/_/assets/logo/logo.png" />
        <meta name="twitter:image:alt" content="{companyName} Logo" />
    {/if}

    <!-- isArticle – article-Meta-Tags bei Bedarf aktivieren -->
</svelte:head>
